<template>
  <div id="billboard" :class="{'logged': User.token}">

    <NoAccount v-if="!User.token"></NoAccount>

    <template v-if="User.token">

      <div class="tabs" :class="{desktop: $store.state.isDesktop}">
        <div class="tab" :class="{active: filter === 'published'}" @click="setFilter('published')">{{ $t("billboard.published") }}</div>
        <div class="tab" :class="{active: filter === 'pending'}" @click="setFilter('pending')">{{ $t("billboard.not_published") }}</div>
        <div class="filler"></div>
      </div>

      <div class="scroll" ref="scroll">
        <template v-for="(post, postIndex) of posts">
          <!-- Existing post -->
          <div v-if="post.id" class="post" :key="String(post.id) + post.name" @click="toPost(post.id)">
            <div class="image" v-if="image(post)" :style="{'background-image': 'url(' + image(post) + ')'}"></div>
            <div class="image empty" v-if="!image(post)">
              <svgicon v-if="$store.state.cogir" src="svg/octo.svg" :height="50" :width="50"></svgicon>
              <svgicon v-if="!$store.state.cogir" src="svg/humaniti.svg" :height="50" :width="50"></svgicon>
            </div>
            <div class="middle">
              <v-clamp class="title" :max-lines="1">{{ $to(post.title) }}</v-clamp>
              <div class="subtitle">{{ formatDate(post.createdAt) }}</div>
              <v-clamp class="message" :max-lines="$store.state.isDesktop ? 3:2" v-if="filter === 'published'">{{ $to(post.body) }}</v-clamp>
              <div class="message" v-if="filter === 'pending'">{{ $t("status") }} : {{ $t("billboard.status." + post.status) }}</div>
            </div>
            <div class="arrow" v-show="!$store.state.isDesktop">
              <svgicon src="svg/arrow.svg" :width=11 :height=20></svgicon>
            </div>
          </div>
          <!-- Placeholder post -->
          <div v-if="!post.id" class="placeholder-post" :key="'placeholder-' + postIndex">
            <div class="image"></div>
            <div class="loader"><div class="loaderInner" :class="['delay-' + postIndex]"></div></div>
          </div>
        </template>
        <div class="empty" v-if="posts.length == 0">{{ $t("billboard.no_post") }}</div>
      </div>

      <div class="footer" :class="{desktop: $store.state.isDesktop}">
        <div class="btn btn-primary" @click="newPost">{{ $t("billboard.new_text") }}</div>

        <div class="pagination" v-show="$store.state.isDesktop">
          <div class="page first" @click="loadPage(1)" :class="{disabled: currentPage == 1}"><div>&lsaquo;&lsaquo;</div></div>
          <div class="page previous" @click="previousPage()" :class="{disabled: currentPage == 1}"><div>&lsaquo;</div></div>
          <div class="page" v-for="page in pages" :key="page" @click="loadPage(page)"
            :class="{active: page == currentPage}">{{ page }}</div>
          <div class="page next" @click="nextPage()" :class="{disabled: currentPage == pages}"><div>&rsaquo;</div></div>
          <div class="page last" @click="loadPage(pages)" :class="{disabled: currentPage == pages}"><div>&rsaquo;&rsaquo;</div></div>
        </div>
      </div>
    </template>


  </div>
</template>

<script>

  import NoAccount from "../components/NoAccount.vue";
  import User from '../../core/User';
  import Billboard from "../../core/Billboard";

  export default {

    name: "billboard",

    components: { NoAccount },

    data() {
      return {
        User,
        Billboard,
        filter: "published",
        pagePending: 1,
        pagePublished: 1
      };
    },

    async mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "page.billboard",
        headerIcon: "/svg/news.svg"
      });
      Billboard.init();
      if (!this.$store.state.isDesktop) {
        let scroll = /** @type {HTMLElement} */ (this.$refs.scroll);
        scroll.onscroll = e => {
          if (scroll.scrollTop + scroll.clientHeight + 100 > scroll.scrollHeight && this.posts.length < this.count) {
            this.nextPage();
          }
        }
      }
    },

    computed: {
      posts() {
        if (this.$store.state.isDesktop) {
          return this.Billboard.getPage(this.filter == "published", this.pagePending);
        }
        if (this.filter == "published") {
          return this.Billboard.postsPublished;
        }
        return this.Billboard.postsPending;
      },
      count() {
        if (this.filter == "published") {
          return this.Billboard.countPublised;
        }
        return this.Billboard.countPending;
      },
      pages() {
        if (this.filter == "published") {
          return this.Billboard.pagesPublished;
        }
        return this.Billboard.pagesPending;
      },
      currentPage() {
        if (this.filter == "published") {
          return this.pagePublished;
        }
        return this.pagePending;
      },
      image() {
        return post => {
          if (post.image != null) {
            return CONFIG.urlFiles + post.image;
          }
          return "";
        }
      }
    },

    watch: {
      filter() {
        setTimeout(() => {
          this.loadMoreInPage();
        }, 100);
      },
      posts() {
        setTimeout(() => {
          this.loadMoreInPage();
        }, 100);
      }
    },

    methods: {
      toPost(id) {
        this.$router.push("/billboard/" + id);
      },
      newPost() {
        this.$router.push("/new-post");
      },
      formatDate(date) {
        if (this.$ts.state.locale == "en") {
          return date.format("MMMM DD, YYYY | HH:mm");
        }
        return date.format("DD MMMM YYYY | HH:mm");
      },
      setFilter(filter) {
        this.filter = filter;
      },
      loadPage(page) {
        this.Billboard.loadPage(this.filter == "published", page);
        if (this.filter == "published") {
          this.pagePublished = page;
        } else {
          this.pagePending = page;
        }
      },
      previousPage() {
        if (this.currentPage <= 1) {
          return;
        }
        this.loadPage(this.currentPage - 1);
      },
      nextPage() {
        if (this.currentPage >= this.pages) {
          return;
        }
        this.loadPage(this.currentPage + 1);
      },
      loadMoreInPage() {
        if (this.$store.state.isDesktop) {
          return;
        }
        let scroll = /** @type {HTMLElement} */ (this.$refs.scroll);
        if (scroll.scrollHeight <= scroll.clientHeight && this.posts.filter(p => !!p.id).length == this.Billboard.pagination) {
          this.nextPage();
        }
      }
    }

  }

</script>

<style lang="scss" scoped>

  #billboard {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }

  .empty {
    color: #888;
    font-size: 14px;
  }

  .tabs {
    display: flex;
    color: #808b91;
    flex-shrink: 0;

    .tab {
      height: 40px;
      flex-basis: 0;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.active {
        font-weight: 500;
      }
    }
  }

  .post {
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    overflow: hidden;
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
    .image {
      flex-shrink: 0;
      background-size: cover;
      background-position: center;
      background-color: #e5e8e9;
      &.empty {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color:rgba(0,0,0,0.15) !important;
        fill: white;
        .svgicon {
          opacity: 0.6;
        }
      }
    }
    .middle {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .subtitle {
        color: #808b91;
      }
      .message {
        color: #405159;
      }
      .title, .message {
        word-break: break-all;
      }
    }
    .arrow {
      width: 30px;
      background-color: #f2f3f4;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      .svgicon {
        fill: #808b91;
      }
    }
  }

  .placeholder-post {
    background-color: white;
    border-radius: 3px;
    position: relative;
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
    .image {
      width: 250px;
      height: 156px;
      background-color: #e5e8e9;
    }
    .loader {
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #bfc5c8;
      .loaderInner {
        height: 100%;
        background-color: #808b91;
        animation: loaderInner 2s linear infinite;
        @keyframes loaderInner {
          0% {
            width: 0px;
          }
          49% {
            float: left;
          }
          50% {
            width: 100%;
            float: right;
          }
          100% {
            width: 0px;
            float: right;
          }
        }
        &.delay-1 { animation-delay: -0.5s; }
        &.delay-2 { animation-delay: -1.0s; }
        &.delay-3 { animation-delay: -1.5s; }
        &.delay-4 { animation-delay: -2.0s; }
        &.delay-5 { animation-delay: -2.5s; }
      }
    }
  }

  .btn {
    flex-grow:1;
  }

  .scroll {
    flex-grow: 1;
    padding: 0 20px;
  }

  .footer {
    padding: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .pagination {
    display: flex;
    div:not(:last-of-type) {
      margin-right: 10px;
    }
    .page {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border-radius: 4px;
      color: #808b91;
      cursor: pointer;
      transition: box-shadow 0.2s ease;
      &:hover {
        box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
      }
      &.active {
        background-color: #808b91;
        color: white;
      }
      &.previous, &.next, &.first, &.last {
        font-size: 32px;
        & > div {
          position: relative;
          top: -4px;
        }
      }
      &.disabled {
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {

    .scroll {
      padding: 20px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .placeholder-post .image {
      width: 100px;
      height: 100px;
    }

    .post {
      .image {
        min-height: 100px;
        width: 100px;
      }
      .middle {
        padding: 10px 10px;
        .subtitle {
          font-size: 12px;
          margin-bottom: 10px;
        }
        .message {
          font-size: 14px;
        }
      }
      .arrow {
        width: 30px;
        background-color: #f2f3f4;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        .svgicon {
          fill: #808b91;
        }
      }
    }

    .tabs {
      background-color: #001722;
      border-top: 1px solid #405159;
      .tab {
        flex-grow: 1;
        &.active {
          color: white;
          font-weight: bold;
          box-shadow: inset 0 -4px #405159;
        }
      }
    }
  }

  @media screen and (min-width: 601px) and (max-width: 1100px) {
    #billboard {
      .post .image {
        width: 150px;
      }
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {

    .scroll {
      margin-left: -20px;
    }

    #billboard {
      &.logged{
        padding:30px 60px 30px 60px;
      }
      &:not(.logged) {
        display:flex;
        flex-direction: row;
        justify-content: center;
        align-items:baseline;
      }
    }

    .post {
      cursor: pointer;
      .image {
        min-height: 156px;
        width: 250px;
      }
      .middle {
        font-size:22px;
        padding: 10px 30px;
        .title {
          font-weight: 700;
        }
        .subtitle {
          font-size: 14px;
          margin-bottom: 16px;
        }
        .message {
          font-size: 16px;
          min-height:66px;
        }
      }
    }

    .tabs {
      background-color: #f2f3f4;
      margin-bottom: 30px;
      .filler {
        flex-grow: 1;
        border-bottom: 5px solid #e6e6e6;
      }
      .tab {
        min-width:175px;
        padding: 0 18px;
        font-size: 16px;
        line-height: 1;
        text-align: center;
        text-decoration: none;
        border-bottom: 5px solid #e6e6e6;
        transition: border-bottom-color 0.2s ease-in-out;
        color: #808080;
        &.active, &.router-link-active {
          color: #404040;
          font-weight: 500;
          border-bottom: 5px solid #808b91;
          cursor: auto;
        }
        &:hover {
          border-bottom: 5px solid #808b91;
        }
        &.disabled {
          color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
        }
      }
    }

    .footer {
      padding:20px 0 20px 0;
    }
    .btn-primary{
      min-width:180px;
      flex-grow:0;
    }
  }

</style>